// ---------------------------------
const menuToggle = () => {
  const menu = document.querySelector(".menu-js");
  if (menu) {
    const html = document.documentElement,
      page = document.querySelector(".page-content-js"),
      overlay = document.querySelector("#overlay-js"),
      openButtons = document.querySelectorAll(".menu-open-js"),
      closeButtons = document.querySelectorAll(".menu-close-js"),
      header = document.querySelector(".header-js"),
      submenu = document.querySelector(".sub-menu-list-block-js"),
      menuList = document.querySelector(".menu-list-block-js");

    let currentMenu;
    // ---------------------------------
    const overlayClose = () => {
      overlay.classList.add("fade-out");
      overlay.classList.remove("fade-in");
      overlay.addEventListener("animationend", fadeOut);
    };
    const fadeOut = () => {
      overlay.style.display = "none";
      overlay.classList.remove("fade-out");
      overlay.removeEventListener("animationend", fadeOut);
    };

    const menuClose = () => {
      const menu = document.querySelectorAll(".menu-js");
      menu.forEach((el) => {
        el.classList.remove("open");
      });
    };

    const removeStyle = () => {
      html.style.overflow = "";
      page && page.classList.remove("right", "left");
      header && header.classList.remove("right", "left");
    };

    const sabmenuClose = () => {
      if (submenu) {
        submenu.classList.add("hidden");
        submenu.classList.remove("visible");
      }
      menuList && menuList.classList.remove("hidden");
    };

    // ---------------------------------

    openButtons.forEach((button) => {
      button.addEventListener("click", (e) => {
        e.preventDefault();

        const menu = document.querySelector(button.dataset.menu);
        const pageClass = button.dataset.pageClass;

        html.style.overflow = "hidden";
        menu.classList.add("open");

        if (!overlay.classList.contains("fade-in")) {
          overlay.style.display = "block";
          overlay.classList.add("fade-in");
        }
        if (page && pageClass && !page.classList.contains(pageClass)) {
          page.classList.add(pageClass);
        }
        if (header && pageClass && !header.classList.contains(pageClass)) {
          header.classList.add(pageClass);
        }
      });
    });
    // ---------------------------------

    closeButtons.forEach((button) => {
      button.addEventListener("click", (el) => {
        const menu = el.target.closest(".menu-js");
        menu.classList.remove("open");
        overlayClose();
        removeStyle();
        sabmenuClose();
      });
    });
    // ---------------------------------

    overlay.addEventListener("click", function () {
      overlayClose();
      menuClose();
      removeStyle();
      sabmenuClose();
    });
  }
};

// ---------------------------------
// sub-menu
// ---------------------------------

// const submenuToggle = () => {
//   const openButton = document.querySelector(".sub-menu-open-js"),
//     closeButton = document.querySelector(".sub-menu-close-js"),
//     submenu = document.querySelector(".sub-menu-list-block-js"),
//     menuList = document.querySelector(".menu-list-block-js");

//   const sabmenuClose = () => {
//     if (submenu) {
//       submenu.classList.add("hidden");
//       submenu.classList.remove("visible");
//     }
//     menuList && menuList.classList.remove("hidden");
//   };

//   openButton.addEventListener("click", (e) => {
//     e.preventDefault();
//     if (submenu) {
//       submenu.classList.remove("hidden");
//       submenu.classList.add("visible");
//     }
//     menuList && menuList.classList.add("hidden");
//   });
//   closeButton.addEventListener("click", (e) => {
//     e.preventDefault();
//     sabmenuClose();
//   });
// };

// ---------------------------------
// menu-modal
// ---------------------------------
// const menuModal = () => {
//   const modal = document.getElementById("menu-modal-js");
//   if (modal) {
//     const modalInner = document.querySelector(".menu-modal-inner-js"),
//       modalOverlay = document.querySelector(".menu-modal-overlay-js"),
//       openButtons = document.querySelectorAll(".menu-modal-open-js");
//     let isOpen = false;
//     let activeButton;

//     const modalClose = () => {
//       modalInner.classList.add("fade-out");
//       modalInner.classList.remove("fade-in");
//       modalOverlay.classList.add("translate-left");
//       modalOverlay.classList.remove("translate-right");
//       modalOverlay.addEventListener("animationend", fadeOut);
//     };
//     const fadeOut = () => {
//       modal.style.display = "none";
//       modalInner.classList.remove("fade-out", "fade-in");
//       modalOverlay.classList.remove("translate-left", "translate-right");
//       modalOverlay.removeEventListener("animationend", fadeOut);
//       isOpen = false;
//       document.removeEventListener("click", handlerDocument);
//     };

//     const handlerDocument = (e) => {
//       if (!e.target.closest(".menu-modal-open-js") && isOpen) {
//         modalClose();
//         activeButton && activeButton.classList.remove('is-active');
//       }
//     };

//     openButtons.forEach((button) => {
//       button.addEventListener("click", (e) => {
//         e.preventDefault();
//         if (!isOpen) {
//           modal.style.display = "block";
//           modalOverlay.classList.add("translate-right");
//           modalInner.classList.add("fade-in");
//           isOpen = true;
//           document.addEventListener("click", handlerDocument);
//         }
//         modalInner.scrollTop = 0;
//         activeButton && activeButton.classList.remove('is-active');
//         activeButton = button;
//         activeButton.classList.add('is-active');
//       });
//     });
//   }
// };

// ---------------------------------

document.addEventListener("DOMContentLoaded", () => {
  menuToggle();
  // submenuToggle();
  // menuModal();
});
